import { ARTICLE_QUERY, ARTICLE_SEARCH } from '../queries';
import query from '../utils/grappa';
export const ARTICLES_FETCH_SIZE = 1000;
export async function fetchArticle(articleId, languageId) {
    const res = await query(ARTICLE_QUERY, {
        articleId,
        pageUrl: window.location.toString(),
        languageId,
        paging: {
            first: ARTICLES_FETCH_SIZE,
            offset: 0,
        },
    });
    return res;
}
export const SEARCH_PAGE_SIZE = 10;
export async function searchArticles({ controller, term, languageId, offset = 0, }) {
    const res = await query(ARTICLE_SEARCH, {
        pageUrl: window.location.toString(),
        languageId,
        query: {
            paging: {
                first: SEARCH_PAGE_SIZE,
                offset,
            },
            terms: term,
        },
    }, controller);
    return res;
}
//# sourceMappingURL=article.js.map